import React from 'react';

function Testimonials() {
  return (
    <section className="tc-testimonials-style1">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <h6 className="fsz-18 text-uppercase db-color lh-4">
              what clients say <br /> about us
            </h6>
            <div className="lg-icon db-color">
              <i className="la la-quote-right"></i>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="tc-clients-style1"> 
              <div className="clients-slider1">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-25 fw-400 lh-2 ">
                      "Our dream home came to life with DB Architekt! Their attention to detail and seamless design approach made the process stress-free. We are beyond thrilled with the results."
                      </div>
                      <div className="author">
                        <div className="au-img">
                          <img
                            src="/home1/assets/img/team/db-architekt-team.png"
                            alt=""
                            className="img-cover"
                          />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                          Ravi Mehta
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                            Gurgaon
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-25 fw-400 lh-2">
                      "DB Architekt’s team is highly professional and creative. They turned our vague ideas into a stunning and functional space. We couldn’t be happier with their work."
                      </div>
                      <div className="author">
                        <div className="au-img">
                          <img
                            src="/home1/assets/img/team/db-architekt-team.png"
                            alt=""
                            className="img-cover"
                          />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                          Priya Gupta
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                          Delhi
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-25 fw-400 lh-2">
                      "From the initial consultation to the final touches, DB Architekt exceeded our expectations. Their designs are not only beautiful but also practical. We highly recommend them!"
                      </div>
                      <div className="author">
                        <div className="au-img">
                          <img
                            src="/home1/assets/img/team/db-architekt-team.png"
                            alt=""
                            className="img-cover"
                          />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                          Anil Kapoor
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                          New Delhi
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slider-controls">
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-pagination"></div>
                  <div className="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="marq-slider">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <a href="#"> Innovative </a>
          </div>
          <div className="swiper-slide">
            <a href="#">Adjustable </a>
          </div>
          <div className="swiper-slide">
            <a href="#"> Committed </a>
          </div>
        </div>
      </div>
      <img src="/home1/assets/img/c_line3.png" alt="" className="c-line" />
    </section>
  );
}

export default Testimonials;
